// Curated reading plans + a generated Bible-in-a-Year (straight + blended) and
// topical plans. Each day is a list of {book, chapter, label}.
const r = (book, from, to, name) => {
  const days = [];
  for (let c = from; c <= to; c++) days.push([{ book, chapter: c, label: `${name} ${c}` }]);
  return days;
};

// Canonical 66-book order: [id, name, chapters]
const BOOKS = [
  ["GEN", "Genesis", 50], ["EXO", "Exodus", 40], ["LEV", "Leviticus", 27],
  ["NUM", "Numbers", 36], ["DEU", "Deuteronomy", 34], ["JOS", "Joshua", 24],
  ["JDG", "Judges", 21], ["RUT", "Ruth", 4], ["1SA", "1 Samuel", 31],
  ["2SA", "2 Samuel", 24], ["1KI", "1 Kings", 22], ["2KI", "2 Kings", 25],
  ["1CH", "1 Chronicles", 29], ["2CH", "2 Chronicles", 36], ["EZR", "Ezra", 10],
  ["NEH", "Nehemiah", 13], ["EST", "Esther", 10], ["JOB", "Job", 42],
  ["PSA", "Psalm", 150], ["PRO", "Proverbs", 31], ["ECC", "Ecclesiastes", 12],
  ["SNG", "Song of Songs", 8], ["ISA", "Isaiah", 66], ["JER", "Jeremiah", 52],
  ["LAM", "Lamentations", 5], ["EZK", "Ezekiel", 48], ["DAN", "Daniel", 12],
  ["HOS", "Hosea", 14], ["JOL", "Joel", 3], ["AMO", "Amos", 9],
  ["OBA", "Obadiah", 1], ["JON", "Jonah", 4], ["MIC", "Micah", 7],
  ["NAM", "Nahum", 3], ["HAB", "Habakkuk", 3], ["ZEP", "Zephaniah", 3],
  ["HAG", "Haggai", 2], ["ZEC", "Zechariah", 14], ["MAL", "Malachi", 4],
  ["MAT", "Matthew", 28], ["MRK", "Mark", 16], ["LUK", "Luke", 24],
  ["JHN", "John", 21], ["ACT", "Acts", 28], ["ROM", "Romans", 16],
  ["1CO", "1 Corinthians", 16], ["2CO", "2 Corinthians", 13], ["GAL", "Galatians", 6],
  ["EPH", "Ephesians", 6], ["PHP", "Philippians", 4], ["COL", "Colossians", 4],
  ["1TH", "1 Thessalonians", 5], ["2TH", "2 Thessalonians", 3], ["1TI", "1 Timothy", 6],
  ["2TI", "2 Timothy", 4], ["TIT", "Titus", 3], ["PHM", "Philemon", 1],
  ["HEB", "Hebrews", 13], ["JAS", "James", 5], ["1PE", "1 Peter", 5],
  ["2PE", "2 Peter", 3], ["1JN", "1 John", 5], ["2JN", "2 John", 1],
  ["3JN", "3 John", 1], ["JUD", "Jude", 1], ["REV", "Revelation", 22],
];

// flat ordered list of every chapter as {book, chapter, label}
const ALL = [];
const OT = [];
const NT = [];
BOOKS.forEach(([id, name, ch], bi) => {
  for (let c = 1; c <= ch; c++) {
    const entry = { book: id, chapter: c, label: `${name} ${c}` };
    ALL.push(entry);
    (bi < 39 ? OT : NT).push(entry);
  }
});

// Straight-through: 1,189 chapters split across 365 days (~3-4/day)
function straightYear() {
  const days = [];
  const total = ALL.length;
  for (let d = 0; d < 365; d++) {
    const from = Math.floor((d * total) / 365);
    const to = Math.floor(((d + 1) * total) / 365);
    days.push(ALL.slice(from, to));
  }
  return days;
}

// Blended: each day = 2 OT chapters + 1 NT chapter + a Psalm + a Proverb
function blendedYear() {
  const days = [];
  for (let d = 0; d < 365; d++) {
    const day = [];
    day.push(OT[(d * 2) % OT.length]);
    day.push(OT[(d * 2 + 1) % OT.length]);
    day.push(NT[d % NT.length]);
    day.push({ book: "PSA", chapter: (d % 150) + 1, label: `Psalm ${(d % 150) + 1}` });
    day.push({ book: "PRO", chapter: (d % 31) + 1, label: `Proverbs ${(d % 31) + 1}` });
    days.push(day);
  }
  return days;
}

// Topical plans — one curated chapter per day
const NAME = Object.fromEntries(BOOKS.map(([id, name]) => [id, name]));
const topic = (pairs) =>
  pairs.map(([b, c]) => [{ book: b, chapter: c, label: `${NAME[b]} ${c}` }]);

const TOPICAL = [
  ["anxiety", "Anxiety & Worry", "Find peace when your mind races", "#6E8FB0",
    [["PHP", 4], ["MAT", 6], ["PSA", 23], ["1PE", 5], ["PSA", 46], ["ISA", 41], ["JHN", 14]]],
  ["depression", "Hope in the Darkness", "Comfort for heavy, weary days", "#5C7A8A",
    [["PSA", 42], ["PSA", 34], ["LAM", 3], ["PSA", 40], ["ISA", 40], ["ROM", 8], ["2CO", 4]]],
  ["fear", "Courage Over Fear", "Stand firm when you're afraid", "#C0563B",
    [["PSA", 27], ["ISA", 41], ["2TI", 1], ["JOS", 1], ["PSA", 91], ["MAT", 8], ["1JN", 4]]],
  ["faith", "Growing in Faith", "Trust God more deeply", "#E0B85C",
    [["HEB", 11], ["ROM", 4], ["JAS", 2], ["MRK", 9], ["MAT", 17], ["GAL", 3], ["HEB", 12]]],
  ["marriage", "Marriage & Love", "God's design for covenant love", "#C77B8B",
    [["GEN", 2], ["EPH", 5], ["1CO", 13], ["COL", 3], ["PRO", 31], ["SNG", 8], ["1PE", 3]]],
  ["conflict", "When You're Arguing", "Wisdom for conflict & hard talks", "#8A6E5C",
    [["PRO", 15], ["MAT", 18], ["JAS", 4], ["EPH", 4], ["ROM", 12], ["PRO", 17], ["COL", 3]]],
  ["anger", "Taming Anger", "Cool a hot temper God's way", "#B0563B",
    [["PRO", 14], ["EPH", 4], ["JAS", 1], ["PSA", 37], ["PRO", 29], ["MAT", 5], ["COL", 3]]],
  ["forgiveness", "Learning to Forgive", "Release the weight of resentment", "#7E9C7A",
    [["MAT", 18], ["COL", 3], ["EPH", 4], ["LUK", 15], ["PSA", 51], ["MRK", 11], ["1JN", 1]]],
  ["grief", "Through Grief & Loss", "Walk with God in sorrow", "#6E7E8F",
    [["PSA", 34], ["JHN", 11], ["2CO", 1], ["REV", 21], ["PSA", 23], ["MAT", 5], ["ROM", 8]]],
  ["submission", "Humility & Submission", "Surrender and trust His lead", "#7A8A9C",
    [["JAS", 4], ["1PE", 2], ["ROM", 13], ["HEB", 13], ["EPH", 5], ["PHP", 2], ["1PE", 5]]],
  ["leadership", "Leading Like Christ", "Servant leadership in Scripture", "#C0a04b",
    [["PRO", 16], ["1TI", 3], ["TIT", 1], ["MAT", 20], ["JHN", 13], ["NEH", 1], ["EXO", 18]]],
  ["following", "Following Jesus", "What it means to truly follow", "#5C8A6E",
    [["LUK", 9], ["MAT", 16], ["JHN", 10], ["MRK", 8], ["LUK", 14], ["JHN", 21], ["MAT", 4]]],
];

export const PLANS = [
  {
    id: "bible-year-straight",
    title: "Bible in a Year — Straight Through",
    subtitle: "Genesis to Revelation in 365 days",
    days: straightYear(),
    accent: "#E0B85C",
    category: "year",
    blurb: "Read the whole Bible in order, about 3–4 chapters a day for one year.",
  },
  {
    id: "bible-year-blended",
    title: "Bible in a Year — Blended",
    subtitle: "OT + NT + a Psalm + a Proverb daily",
    days: blendedYear(),
    accent: "#5C8A6E",
    category: "year",
    blurb: "A daily mix of Old Testament, New Testament, a Psalm and a Proverb for one year.",
  },
  ...TOPICAL.map(([id, title, blurb, accent, pairs]) => ({
    id: `topic-${id}`,
    title,
    subtitle: `${pairs.length}-day topical plan`,
    days: topic(pairs),
    accent,
    category: "topical",
    blurb,
  })),
  {
    id: "john-21",
    title: "The Life of Jesus",
    subtitle: "The Gospel of John",
    days: r("JHN", 1, 21, "John"),
    accent: "#E0B85C",
    category: "classic",
    blurb: "Walk through Jesus' life, words, and miracles in 21 days.",
  },
  {
    id: "gospels-30",
    title: "Gospels in 30 Days",
    subtitle: "Matthew → John highlights",
    days: [
      ...r("MAT", 1, 9, "Matthew"),
      ...r("MRK", 1, 8, "Mark"),
      ...r("LUK", 1, 8, "Luke"),
      ...r("JHN", 1, 5, "John"),
    ],
    accent: "#5C8A6E",
    category: "classic",
    blurb: "A fast-moving sweep through the four Gospels.",
  },
  {
    id: "proverbs-31",
    title: "Wisdom in 31 Days",
    subtitle: "A chapter of Proverbs a day",
    days: r("PRO", 1, 31, "Proverbs"),
    accent: "#D4AF37",
    category: "classic",
    blurb: "One short chapter of practical wisdom every day.",
  },
  {
    id: "psalms-peace",
    title: "Psalms of Peace",
    subtitle: "14 days of comfort",
    days: [23, 27, 46, 91, 121, 16, 34, 42, 62, 103, 116, 131, 139, 145].map((c) => [
      { book: "PSA", chapter: c, label: `Psalm ${c}` },
    ]),
    accent: "#6E8FB0",
    category: "classic",
    blurb: "Hand-picked psalms to calm an anxious mind.",
  },
  {
    id: "romans-16",
    title: "Foundations of Faith",
    subtitle: "The book of Romans",
    days: r("ROM", 1, 16, "Romans"),
    accent: "#C0563B",
    category: "classic",
    blurb: "Understand grace, faith, and the gospel in 16 days.",
  },
];

export const getPlan = (id) => PLANS.find((p) => p.id === id);

// Flatten a plan into an ordered list of every chapter with its day index.
export const flattenPlan = (plan) => {
  const flat = [];
  if (!plan) return flat;
  plan.days.forEach((day, dayIdx) => {
    day.forEach((c) => flat.push({ book: c.book, chapter: c.chapter, label: c.label, dayIdx }));
  });
  return flat;
};
